import { createContext } from "react";
import { EmissionData } from "../models/Emission";
import dayjs from "dayjs";
import { DashboardResults } from "../models/emission-dashboard.types";

export interface DashboardState {
  emissions: EmissionData[];
  filteredEmissions: EmissionData[];
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  dashboardData: DashboardResults | undefined;
}

export const DashboardContext = createContext<DashboardState>({
  emissions: [],
  filteredEmissions: [],
  startDate: dayjs(),
  endDate: dayjs(),
  dashboardData: undefined,
});
